var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSendFilled = function SvgSendFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M4.415 11.25h6.468a.75.75 0 1 1 0 1.5H4.415l-1.602 6.047a1.953 1.953 0 0 0 2.763 2.247l14.598-7.297a1.953 1.953 0 0 0 0-3.494L5.575 2.956a1.953 1.953 0 0 0-2.763 2.247l1.602 6.047Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSendFilled);
export default ForwardRef;